import { COLOR_INTROS } from '../data/color-intros';
import type { ColorCategory } from '../types';
import { pinTooltipBelow } from './tooltip-pin';

// Singleton tooltip element + global dismiss handlers, created once at
// module load. The getElementById fallback keeps HMR re-evals idempotent.
const tooltip: HTMLElement = (() => {
  const existing = document.getElementById('global-color-tooltip');
  if (existing) return existing;
  const t = document.createElement('div');
  t.id = 'global-color-tooltip';
  t.className = 'tooltip';
  document.body.appendChild(t);
  return t;
})();

export const hideColorTooltip = (): void => tooltip.classList.remove('show', 'below');

// Outside-click dismiss: face clicks call stopPropagation, so this only fires
// for clicks elsewhere. Hide on resize too — stale coords after rotation
// would otherwise leave the tooltip pinned where the card USED to be.
document.addEventListener('click', hideColorTooltip);
window.addEventListener('resize', hideColorTooltip);

export function attachColorTooltip(faceEl: HTMLElement, category: ColorCategory): void {
  const info = COLOR_INTROS[category];

  const setText = (): void => {
    tooltip.innerHTML = `
      <div class="t-name">${category.toUpperCase()}</div>
      <div class="t-good"><span lang="en">${info.en}</span><span lang="zh">${info.zh}</span></div>`;
  };

  if (matchMedia('(max-width: 720px)').matches) {
    faceEl.addEventListener('click', (e) => {
      e.stopPropagation();
      setText();
      pinTooltipBelow(tooltip, faceEl);
    });
  } else {
    const moveTo = (e: MouseEvent): void => {
      tooltip.style.left = `${e.clientX}px`;
      tooltip.style.top = `${e.clientY - 20}px`;
    };
    faceEl.addEventListener('mouseenter', (e) => {
      setText();
      moveTo(e);
      tooltip.classList.add('show');
    });
    faceEl.addEventListener('mousemove', moveTo);
    faceEl.addEventListener('mouseleave', hideColorTooltip);
  }
}
